<template>
	<b-form-group
		:label="`${label + asterisk}`"
		:label-for="`input-${name}-${_uid}`"
		:label-class="{
			'label-light-grey': true,
			'is-invalid': currentState == false,
		}">
		<b-form-input
			:id="`input-${name}-${_uid}`"
			:type="type"
			:class="{ open: focused || isOpen }"
			:state="currentState"
			:required="required"
			:value="value"
			v-mask="mask"
			v-bind="$attrs"
			@focus="focused = true"
			@blur="focused = false"
			@input="handleInput"
			:maxlength="maxlength"></b-form-input>
	</b-form-group>
</template>
<script>
export default {
	name: "InputComponent",
	props: {
		name: String,
		type: String,
		label: String,
		required: Boolean,
		mask: String,
		check: Boolean,
		max: String,
		maxlength: String,
		value: String,
	},
	data() {
		return {
			focused: false,
		};
	},
	computed: {
		currentState() {
			if (!this.$parent.$v[this.name].$dirty) {
				return null;
			}

			if (this.$parent.$v[this.name].$error && this.required) {
				return false;
			}

			if (!this.$parent.$v[this.name].$error && this.check) {
				return true;
			}

			return null;
		},
		asterisk() {
			return this.required ? "*" : "";
		},
		isOpen() {
			return this.value;
		},
	},
	methods: {
		setValue(newVal) {
			this.$emit("input", newVal);
			this.$parent.$v?.[this.name]?.$touch();
		},
		handleInput(newVal) {
			let finalValue = newVal;

			if (this.max && parseInt(newVal) > parseInt(this.max)) {
				finalValue = this.max + "%";
			}

			this.setValue(finalValue);
		},
	},
	inheritAttrs: false,
};
</script>
<style lang="scss"></style>
